import Immerable from "../../../store/immerable";

export enum NotificationType {
    Information, Success, Failure, Warning, Error
}

export class SessionNotification extends Immerable {
    id: string;
    message: string;
    type: NotificationType;
    detailedMessage?: string;

    constructor(id: string, message: string, type: NotificationType, detailedMessage?: string) {
        super();
        this.id = id;
        this.message = message;
        this.type = type;
        this.detailedMessage = detailedMessage;
    }
}

export function notificationTypeToBootstrapVariant(type: NotificationType) {
    switch (type) {
        case NotificationType.Success:
            return 'success';
        case NotificationType.Failure:
            return 'danger';
        case NotificationType.Warning:
            return 'warning';
        case NotificationType.Error:
            return 'danger';
        case NotificationType.Information:
        default:
            return 'secondary';
    }
}
